/*
  Writes the team store the shopper is browsing to the cart attribute "_team_store", then
  refreshes the cart drawer so the swag upsell reflects it. Works with
  snippets/team-store-tracker.liquid. Added 2026-09. AP
*/
(function () {
  var store = window.SL_TEAM_STORE;
  if (!store || typeof store !== 'string') return;
  if ((window.SL_CART_TEAM_STORE || '') === store) return;

  var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update.js';

  fetch(updateUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { _team_store: store } }),
  })
    .then(function (response) {
      if (!response.ok) throw new Error('cart/update failed: ' + response.status);
      return response.json();
    })
    .then(function () {
      window.SL_CART_TEAM_STORE = store;
      refreshDrawer();
    })
    .catch(function (e) {
      console.warn('team-store-tracker', e);
    });

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    var target = document.getElementById('CartDrawer');
    if (!drawer || !target) return;
    if (drawer.classList.contains('active')) return; // do not swap content under an open drawer

    fetch(window.location.pathname + '?section_id=cart-drawer', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
        if (!fresh) return;
        target.innerHTML = fresh.innerHTML;
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') {
          overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      })
      .catch(function (e) {
        console.warn('team-store-tracker refresh', e);
      });
  }
})();
